import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function ChangePasswordModal({ open, onClose }) {
  const [oldP, setOld] = useState("");
  const [newP, setNew] = useState("");
  const [loading, setLoading] = useState(false);
  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (newP.length < 6) return toast.error("Password must be ≥ 6 chars");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { old_password: oldP, new_password: newP });
      toast.success("Password updated");
      onClose(); setOld(""); setNew("");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/60 flex items-center justify-center p-4" data-testid="change-pwd-modal">
      <div className="bg-white max-w-sm w-full border border-[var(--border)]">
        <div className="px-7 py-5 border-b border-[var(--border)] bg-[var(--bg)] flex justify-between items-center">
          <h3 className="font-display text-2xl">Change Password</h3>
          <button onClick={onClose} className="text-2xl">×</button>
        </div>
        <form onSubmit={submit} className="p-7 space-y-4">
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-[var(--muted)] mb-2 block">Current Password</span>
            <input type="password" required value={oldP} onChange={e => setOld(e.target.value)} data-testid="old-password"
              className="w-full bg-[var(--bg)] border border-[var(--border)] px-4 py-2.5 focus:outline-none focus:border-[var(--accent)]" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-[var(--muted)] mb-2 block">New Password (min 6)</span>
            <input type="password" required minLength={6} value={newP} onChange={e => setNew(e.target.value)} data-testid="new-password"
              className="w-full bg-[var(--bg)] border border-[var(--border)] px-4 py-2.5 focus:outline-none focus:border-[var(--accent)]" />
          </label>
          <button type="submit" disabled={loading}
            className="btn-gold w-full rounded-full py-3 text-sm tracking-widest uppercase disabled:opacity-60" data-testid="change-pwd-submit">
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
      </div>
    </div>
  );
}
